import cn from "classnames"
import React from "react"
import { Modal, ModalHeader } from "reactstrap"
import { CloseIcon } from "../../icons/CloseIcon"
import "./BaseModal.scss"
import { IModalCallback } from "./modalTypes"

interface IBaseModalProps {
    title?: string
    size?: string
    id?: string
    fullSize?: boolean
    centered?: boolean
    noBorderTop?: boolean
    noBordersInside?: boolean
    isOpen: boolean
    onClosed: () => void
    showCloseButton?: boolean
    children?: React.ReactNode
    modalClassName?: string
    autoFocus?: boolean
    titleClassName?: string
}

export const BaseModal = ({
    title,
    showCloseButton,
    size,
    id,
    centered,
    noBorderTop,
    fullSize,
    noBordersInside,
    children,
    isOpen,
    modalClassName,
    autoFocus,
    titleClassName,
    onClosed,
    callback,
}: IBaseModalProps & IModalCallback) => {
    return (
        <Modal
            wrapClassName={cn(
                "swiipe-modal-container",
                {
                    "no-borders-inside": !!noBordersInside,
                    "full-size": !!fullSize,
                },
                {
                    "no-border-top": noBorderTop,
                },
                modalClassName
            )}
            backdrop={true}
            toggle={() => callback("ignored")}
            isOpen={isOpen}
            onClosed={onClosed}
            size={size}
            id={id}
            centered={centered}
            autoFocus={autoFocus}
        >
            {(title || showCloseButton) && (
                <ModalHeader className={cn("swiipe-modal-header", titleClassName)} toggle={undefined}>
                    {title}
                    {showCloseButton && <CloseIcon className="close-cross" onClick={() => callback("ignored")} />}
                </ModalHeader>
            )}
            {children}
        </Modal>
    )
}
